<template>
  <custom-dialog :visible="visible" width="680px" class="project-site-dialog" :title="model.title" v-on="$listeners" appendToBody>
    <div class="dialog-body">
      <div class="msg-content">
        <!-- <div class="title">{{ $t('page_project_qqybq') }}</div> -->
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('dms_project_site_dialog.xiang_mu_ming_cheng') }}</div>
            <div class="val">{{ locationInfo.locationName }}</div>
          </li>
          <li>
            <div class="key">{{ $t('dms_project_site_dialog.qu_yu_biao_qian') }}</div>
            <div class="val">{{ floorInfo.floorName || '-' }}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col>
              <el-form-item :label="$t('dms_project_site_dialog.qu_yu_ming_cheng')">
                <el-input v-model="form.siteName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('dms_project_site_dialog.mbqjmjo', [$formatLenUnit()])" prop="goalArea">
                <el-input v-model="form.goalArea" :disabled="form.isBasicGoal"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('dms_project_site_dialog.mbqjscf')" prop="goalTime">
                <el-input v-model="form.goalTime" :disabled="form.isBasicGoal"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col>
              <el-form-item :label="$t('page_project_qu_yu_mian_ji')" prop="contactName">
                <el-input v-model="form.contactName"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row>
            <el-col>
              <el-form-item :label="$t('page_project_qyqxsct')" prop="contactPhone">
                <el-input v-model="form.contactPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <project-floor-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="updateFloorList"></project-floor-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import projectFloorDialog from '@/pages/dms/components/project_floor_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { projectFloorDialog },
  data() {
    return {
      form: {
        floorId: '', // 区域标签Id
        locationId: '', // 项目Id
        siteId: '', // 编辑时必填
        siteName: '', // 区域名称
        goalArea: '', // 区域面积
        goalTime: '', // 区域清洗时长/天
        timezone: '', // 时区
        isBasicGoal: '',
        // 要删除
        tagId: '',
        orgId: '',
      },
      dialogVisible: false,
      dialogModel: {},
      locationInfo: {},
      floorInfo: {},
    };
  },
  mounted: function () {
    this.initForm();
    this.getFuncView('/project');
    // 借用管理多语言
  },

  computed: {
    rules() {
      return {
        siteName: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
  },
  methods: {
    initForm() {
      if (this.model.type === 'add') {
        this.form.floorId = this.model.data.parentId ? this.model.data.floorId : ''; // 区域标签Id
        this.form.locationId = this.model.data.parentId ? this.model.data.parentId : this.model.data.locationId; // 项目Id
        this.getProjectInfo();
        if (this.form.floorId) {
          this.getFloorInfo();
        }
      } else {
        this.getSiteInfo();
      }
    },
    getProjectInfo() {
      this.$getJSON(apis.locationInfo, { locationId: this.form.locationId }).then((res) => {
        const data = res.data || {};
        this.locationInfo = data;
      });
    },
    getFloorInfo() {
      this.$getJSON(apis.locationFloorInfo, { floorId: this.form.floorId }).then((res) => {
        const data = res.data || {};
        this.floorInfo = data;
      });
    },
    getSiteInfo() {
      this.$getJSON(apis.locationSiteInfo, { siteId: this.model.data.siteId }).then((res) => {
        const data = res.data || {};
        this.locationInfo = data;
        this.floorInfo = data;
        this.$setFormatData(this.form, data);
        this.form.goalArea = this.form.goalArea ? this.$formatLenLocal(this.form.goalArea) : '';
        this.form.isBasicGoal = this.model.data.isBasicGoal;
      });
    },
    updateFloorList() {
      this.$refs.floor.getSelectList();
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.form.goalArea = this.form.goalArea ? this.$formatLenUpload(this.form.goalArea) : '';
      if (this.model.type === 'add') {
        this.add();
      } else {
        this.edit();
      }
    },
    edit() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationSiteUpdate, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_edit_success'),
            });
            this.$emit('success');
            this.closeDialog();
          });
        }
      });
    },
    add() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.locationSiteAdd, this.form, true).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('Common.com_add_success'),
            });
            this.$emit('success');
            this.closeDialog();
          });
        }
      });
    },
    addFloor() {
      const title = this.$t('dms_project_site_dialog.tjqybq');
      this.dialogModel.type = 'add';
      this.dialogModel.title = title;
      this.dialogModel.data = this.model.data;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.project-site-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      // height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
